import { Paper, Grid, Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { FormColumn } from 'components/Form/FormColumn';
import { t } from 'i18next';
import {
  MedicalEventBlankingPeriod,
  MedicalEventDataForm,
  MedicalEventIteration,
  MedicalEventMedicationProtocol,
  MedicalEventMedicationType,
  MedicalEventProcedureCardioversionType,
  MedicalEventProcedureCatheterAblationType,
  MedicalEventProcedureTechnology,
  MedicalEventProcedureVendor,
  MedicalEventTreatmentMethod,
} from 'models/patientMedicalEvent';
import { showBlankingPeriodLabel } from 'utils/logs';

interface FormTreatmentSectionProps {
  form: UseFormReturnType<MedicalEventDataForm, (values: MedicalEventDataForm) => MedicalEventDataForm>;
}

export const FormTreatmentSection = ({ form }: FormTreatmentSectionProps) => {
  return (
    <Paper radius={'md'} p={'md'} withBorder>
      <Grid align={'center'}>
        <FormColumn label={t('add_log_name_label')}>
          <Select
            required
            data={Object.values(MedicalEventTreatmentMethod).map((treatment) => ({
              label: t(`add_log_form_${treatment}`),
              value: treatment,
            }))}
            placeholder={t('add_log_name_label')}
            clearable
            {...form.getInputProps('treatment')}
          />
        </FormColumn>
        {form.getValues().treatment === MedicalEventTreatmentMethod.CatheterAblation && (
          <>
            <FormColumn label={t('add_log_procedure_type')}>
              <Select
                required
                data={Object.values(MedicalEventProcedureCatheterAblationType).map((procedureType) => ({
                  label: t(`add_log_form_${procedureType}`),
                  value: procedureType,
                }))}
                placeholder={t('add_log_procedure_type')}
                clearable
                {...form.getInputProps('procedure')}
              />
            </FormColumn>
            <FormColumn label={t('add_log_iteration')}>
              <Select
                required
                data={Object.values(MedicalEventIteration).map((iteration) => ({
                  label: t(`add_log_form_${iteration}`),
                  value: iteration,
                }))}
                placeholder={t('add_log_iteration')}
                clearable
                {...form.getInputProps('iteration')}
              />
            </FormColumn>
          </>
        )}
        {form.getValues().treatment === MedicalEventTreatmentMethod.Cardioversion && (
          <FormColumn label={t('add_log_procedure_type')}>
            <Select
              required
              data={Object.values(MedicalEventProcedureCardioversionType).map((procedureType) => ({
                label: t(`add_log_form_${procedureType}`),
                value: procedureType,
              }))}
              placeholder={t('add_log_procedure_type')}
              clearable
              {...form.getInputProps('procedure')}
            />
          </FormColumn>
        )}
        {form.getValues().treatment === MedicalEventTreatmentMethod.CatheterAblation && (
          <>
            <FormColumn label={t('add_log_technology')}>
              <Select
                data={Object.values(MedicalEventProcedureTechnology).map((technology) => ({
                  label: t(`add_log_form_${technology}`),
                  value: technology,
                }))}
                placeholder={t('add_log_technology')}
                clearable
                {...form.getInputProps('technology')}
              />
            </FormColumn>
            <FormColumn label={t('add_log_vendor')}>
              <Select
                data={Object.values(MedicalEventProcedureVendor).map((vendor) => ({
                  label: t(`add_log_form_${vendor}`),
                  value: vendor,
                }))}
                placeholder={t('add_log_vendor')}
                clearable
                {...form.getInputProps('vendor')}
              />
            </FormColumn>
            <FormColumn label={t('add_log_blanking_period')}>
              <Select
                data={Object.values(MedicalEventBlankingPeriod).map((weeks) => ({
                  label: showBlankingPeriodLabel(weeks),
                  value: weeks.toString(),
                }))}
                placeholder={t('add_log_blanking_period')}
                {...form.getInputProps('blankingPeriodInWeeks')}
              />
            </FormColumn>
          </>
        )}
        {form.getValues().treatment === MedicalEventTreatmentMethod.Medication && (
          <>
            <FormColumn label={t('add_log_medication_type')}>
              <Select
                data={Object.values(MedicalEventMedicationType).map((medicationType) => ({
                  label: t(`add_log_form_${medicationType}`),
                  value: medicationType,
                }))}
                placeholder={t('add_log_medication_type')}
                {...form.getInputProps('medicationType')}
              />
            </FormColumn>
            <FormColumn label={t('add_log_medication_protocol')}>
              <Select
                data={Object.values(MedicalEventMedicationProtocol).map((medicationProtocol) => ({
                  label: t(`add_log_form_${medicationProtocol}`),
                  value: medicationProtocol,
                }))}
                placeholder={t('add_log_medication_protocol')}
                {...form.getInputProps('medicationProtocol')}
              />
            </FormColumn>
          </>
        )}
      </Grid>
    </Paper>
  );
};
